import clsx from 'clsx'
import { useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../../../../store/hooks/Redux'
import { selectUser } from '../../../../../store/reducers/AuthSlice'
import { useScrollable } from '../../../../../../shared/lib/hooks/UseScrollable'
import {
  getNavGroupIdByPath,
  getVisibleNavigation,
  INavItem,
  isNavGroup,
  isNavLink,
} from '../Navigation.const'
import { NavMenuGroup } from './NavMenuGroup'
import { NavMenuLink } from './NavMenuLink'

export interface INavMenuProps {
  items: INavItem[]
  /** Свёрнутое меню: подписи уходят в тултипы, списки групп — в поповеры */
  collapsed: boolean
  className?: string
  /** Обработчик вложенных пунктов без маршрута (logout и т.п.) */
  onAction?: (id: string) => void
}

/** Меню — самостоятельный аккордеон: внутри открыта одна группа, соседние меню не задевает */
export const NavMenu = ({ items, collapsed, className, onAction }: INavMenuProps) => {
  const { pathname } = useLocation()
  const user = useAppSelector(selectUser)
  const { ref, isScrollable } = useScrollable<HTMLDivElement>()

  // Пункты не для всех: роль и доступы решают, что показать
  const visibleItems = useMemo(() => getVisibleNavigation(items, user), [items, user])
  const [openGroup, setOpenGroup] = useState<string | null>(() =>
    getNavGroupIdByPath(items, pathname),
  )

  const toggleGroup = (id: string) => setOpenGroup((prevState) => (prevState === id ? null : id))

  return (
    <div
      ref={ref}
      className={clsx(className, '-mx-[8px] px-[8px]', {
        ['border-b border-white/20']: isScrollable,
      })}
    >
      {visibleItems.map((item) =>
        isNavGroup(item) ? (
          <NavMenuGroup
            key={item.id}
            collapsed={collapsed}
            group={item}
            open={openGroup === item.id}
            onAction={onAction}
            onToggle={() => toggleGroup(item.id)}
          />
        ) : (
          isNavLink(item) && <NavMenuLink key={item.label} collapsed={collapsed} link={item} />
        ),
      )}
    </div>
  )
}
